export const formatVersionedId = (id: number, versionNumber: number): string => `${id}/${versionNumber}`;
